import { Input, Button, Alert, Checkbox, Row, Col, Spin, Divider } from 'antd';
import { ExclamationCircleFilled,  EyeTwoTone,
  EyeInvisibleOutlined, } from '@ant-design/icons';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  confirmLogin,
  initiateGsisLogin,
  setRememberMe,
} from '../../../store/user/actions';
import { useNavigate, Link } from 'react-router-dom';
import { getSystemLocales } from 'store/forms/actions';
import { getLocalString, localNames } from 'utils/localisation.service';
import { Label, TextField, FormTitle, FormSwitcher } from 'components';
import Πολιτική_Cookies from '../../../assets/documents/Αλλάζω_Συσκευή_Θέρμανσης_και_Θερμοσίφωνα_Πολιτική Cookies.pdf';
import Πολιτική_Απορρήτου from '../../../assets/documents/Αλλάζω_Συσκευή_Θέρμανσης_και_Θερμοσίφωνα_Πολιτική_Απορρήτου.pdf';
import Οδηγός_Εφαρμογής from '../../../assets/documents/ΦΕΚ_Β_6969_Αντλία Θερμότητας _Θερμοσίφωνα.pdf';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(false);
  const { rememberMe } = useSelector(state => state.user);
  const [checked, setChecked] = useState(rememberMe);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locales = useSelector(state => state.forms?.localeStrings);
  const isLoadingLocales = useSelector(state => state.forms?.loadingLocales);
  const inputRef = useRef(null);
  const { hasError, hasInfo, loading, message, gsisAuthUrl } = useSelector(
    state => state.forms.appConfig
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const storedLanguage =
      localStorage.getItem('appLanguage') ||
      process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
    dispatch(getSystemLocales(storedLanguage));
  }, []);

  useEffect(() => {
    // Sync local checked state with Redux rememberMe state
    setChecked(rememberMe);
  }, [rememberMe]);

  const onRememberMeChange = e => {
    dispatch(setRememberMe(e.target.checked));
  };

  const authProviderSubmitClicked = () => {
    dispatch(initiateGsisLogin(gsisAuthUrl));
  };

  const logingcall = () => {
    const payload = {
      j_username: email,
      j_password: password,
      _spring_security_remember_me: checked,
      submit: 'login',
    };

    dispatch(
      confirmLogin(payload, navigate, check => {
        setLoginError(check);
      })
    );
  };

  const handleSubmit = async e => {
    e.preventDefault();
    logingcall();
  };

  return (
    <main>
      <div className="login-page-wrapper">
        <div className="login-page-content">
          {isLoadingLocales ? ( // Display spinner while locales are loading
            <div className="custom-spinner">
              <div>
                <Spin size="large" />
              </div>
            </div>
          ) : (
            <>
              <Row className="page-title-row login-title-row">
                <Col span={24} className="page-title-col login-title-col">
                  <Label
                    label={getLocalString(
                      locales,
                      localNames.LOGIN_PAGE_APPLICATIONLOGIN
                    )}
                    customClass="login-main-title"
                  />
                  <p style={{ textAlign: 'justify' }}>
                    Για την υποβολή και την παρακολούθηση της πορείας της αίτησής σας εισέλθετε
                    στην εφαρμογή χρησιμοποιώντας τους προσωπικούς κωδικούς που έχετε στο Taxisnet.
                  </p>
                  <p>
                    Συνεχίζοντας, επιβεβαιώνετε ότι έχετε διαβάσει και
                    συμφωνείτε με την{' '}
                    <a
                      href={Πολιτική_Απορρήτου}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Πολιτική Απορρήτου
                    </a>
                    , τον{' '}
                    <a
                      href={Οδηγός_Εφαρμογής}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Οδηγό Εφαρμογής του Προγράμματος
                    </a>
                    , και την{' '}
                    <a
                      href={Πολιτική_Cookies}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Πολιτική Cookies
                    </a>
                    .
                  </p>
                </Col>
              </Row>

              <Row className="error-wrapper-row">
                <Col span={24} className="error-wrapper-col">
                  {hasError && (
                    <Alert
                      message="Σφάλμα"
                      description={message}
                      className="error-component"
                      type="error"
                      icon={<ExclamationCircleFilled />}
                      closable
                      showIcon
                    />
                  )}
                  {hasInfo && (
                    <Alert
                      description={message}
                      className="info-component"
                      type="info"
                      icon={<ExclamationCircleFilled />}
                      closable
                      showIcon
                    />
                  )}
                </Col>
              </Row>

              {(gsisAuthUrl && process.env.REACT_APP_LOGIN_TO_PLATFORM === 'true') && (
                <Row className="oauth2-provider-row">
                  <Col xs={24} sm={12} className="oauth2-provider-col">
                    <Button
                      type="primary"
                      className="oauth2-provider-submit"
                      disabled={loading}
                      onClick={authProviderSubmitClicked}
                    >
                      {getLocalString(
                        locales,
                        localNames.LOGIN_PAGE_TAXISLOGIN
                      )}
                    </Button>
                  </Col>
                </Row>
              )}

              <Row className="form-title-row-2">
                <Col xs={24} sm={12} className="form-title-col-2">
                  <Button
                    className="form-title-btn"
                    onClick={() => setOpen(!open)}
                    id="inputExpand"
                  >
                    <FormTitle
                      label={getLocalString(
                        locales,
                        localNames.LOGIN_PAGE_ADMINISTRATORLOGIN
                      )}
                      labelClassName="form-title"
                      forComponent="form-control"
                      open={open}
                    />
                  </Button>
                </Col>
              </Row>

              <Divider className="login-page-divider" />

              {open ? (
                <>
                  {/* <Row className="form-title-row">
                    <Col xs={24} sm={12} className="form-title-col">
                      <span className="login-page-subtitle">
                        Είσοδος με Email
                      </span>
                    </Col>
                  </Row> */}

                  <div className="form-login-wrapper">
                    <Row className="userpass-wrapper-row">
                      <Col xs={24} sm={12} className="userpass-wrapper-col">
                        <div className="form-group">
                          <label className="login-field-label">Όνομα Χρήστη</label>
                          <TextField
                            className="username-component"
                            containerClassName="username-container"
                            fieldName="username"
                            fieldType="text"
                            size="large"
                            id="inputUsername"
                            placeholder={getLocalString(
                              locales,
                              localNames.LOGIN_PAGE_ENTERUSERNAME
                            )}
                            disabled={loading}
                            customRef={inputRef}
                            onPressEnter={handleSubmit}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                          />
                        </div>
                        <div
                          className="form-group"
                          style={{ marginTop: '10px' }}
                        >
                          <label
                            id="labelPassword"
                            className="login-field-label"
                          >
                            {getLocalString(
                              locales,
                              localNames.LOGIN_PAGE_PASSWORDREQUEST
                            )}
                          </label>
                        <Input.Password
                          id="inputPassword"
                          className={`password-like-username ${loginError ? 'error' : ''}`}
                          size="large"
                          placeholder={getLocalString(
                          locales,
                          localNames.LOGIN_PAGE_ENTERPASSWORD
                          )}
                          onChange={e => setPassword(e.target.value)}
                          onPressEnter={handleSubmit}
                          value={password}
                          autoComplete="new-password"
                          iconRender={visible =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                          }
                          />

                          {loginError && (
                            <p style={{ color: 'red', fontSize: '12px' }}>
                              Μη έγκυρο email ή κωδικός, παρακαλώ προσπαθήστε
                              ξανά.
                            </p>
                          )}
                        </div>
                      </Col>
                    </Row>

                    <Row className="userpass-wrapper-row">
                      <Col xs={24} sm={12} className="forgotpass-wrapper-col">
                        <div className="forgotpass-container">
                          <Link
                            to="/forgot-password"
                            className="forgotpass-component"
                            id="inputForgotPassword"
                          >
                            {getLocalString(
                              locales,
                              localNames.LOGIN_PAGE_FORGOTPASSBUTTON
                            )}
                          </Link>
                        </div>
                      </Col>
                    </Row>

                    <Row className="remember-wrapper-row">
                      <Col xs={24} sm={12} className="remember-wrapper-col">
                        <Checkbox
                          className="custom-remember-checkbox"
                          checked={rememberMe}
                          onChange={onRememberMeChange}
                          labelClassName="custom-remember-label"
                          id="inputRememberMe"
                        >
                          {getLocalString(
                            locales,
                            localNames.LOGIN_PAGE_REMEMBERBUTTON
                          )}
                        </Checkbox>
                      </Col>
                    </Row>

                    {process.env.REACT_APP_LOGIN_TO_PLATFORM === 'true' &&
                      <Row className="buttons-wrapper-row">
                        <Col xs={24} sm={12} className="buttons-wrapper-col">
                          <Button
                            type="primary"
                            className="submit-component"
                            disabled={loading}
                            onClick={handleSubmit}
                            id="inputEnter"
                          >
                            {getLocalString(locales, localNames.LOGIN_PAGE_ENTER)}
                          </Button>
                        </Col>
                      </Row>
                    }
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
    </main>
  );
};

export default Login;
